import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '', loadChildren: () => import('./pages/home-page/home-page.routes'),
    },
    {
        path: 'contact-us', loadChildren: () => import('./pages/contact-us/contact-us.routes'),
    },
    {
        path: '**', redirectTo: '/'
    }
];
